import styled from 'styled-components';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

import { productSwitchArchivedHandler } from '../cacheHandlers/productSwitchesCacheHandler';

import {
    GetAllProductsQuery,
    ProductSwitchFragmentFragment,
    useArchiveProductSwitchMutation,
} from 'data/__generated__';

export function ArchiveProductSwitchPopup({
    isOpen,
    setIsOpen,
    products,
    productSwitch,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
    products: GetAllProductsQuery['getAllProducts'];
    productSwitch: ProductSwitchFragmentFragment;
}) {
    const [archiveProductSwitch, { loading: creationLoading }] = useArchiveProductSwitchMutation();

    async function handleSubmit() {
        const { data } = await archiveProductSwitch({ variables: { productSwitchId: productSwitch._id } });

        if (!data) {
            throw new Error("Une erreur est survenue lors de l'archivage du switch de produit");
        }

        const { archiveProductSwitch: updatedProductSwitch } = data;

        productSwitchArchivedHandler(updatedProductSwitch);

        setIsOpen(false);
    }

    const productA = products.find(({ _id }) => _id === productSwitch.productAId);
    const productB = products.find(({ _id }) => _id === productSwitch.productBId);

    return (
        <TotemPopup
            title="Archiver un switch de produit"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            Voulez-vous archiver le switch de produit ?
            <br />
            Produit A : {productA?.fullname ?? 'Erreur'}
            <br />
            Produit B : {productB?.fullname ?? 'Erreur'}
            <SubmitContainer>
                <ValidationButton onClick={handleSubmit} loading={creationLoading} useIcon={false} label="Confirmer" />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15px;
`;

const ValidationButton = styled(TotemPrimaryLoadingButton)`
    margin-top: 15px;
`;
